import React, { useState, useEffect, Fragment, useCallback } from 'react';
import VehicleCardSkeleton from './VehicleCardSkeleton';
import VehicleAdjudgedCard from '../../adjudications/VehicleAdjudgedCard';
import VehicleSoldVWRCard from '../../adjudications/VehicleSoldVWRCard';
import VehicleDealerReceptorCard from '../../dealerReceptor/VehicleDealerReceptorCard';
import Pagination from '../../bronson/Pagination';

import VehicleAuctionCard from 'components/auctions/AuctionVehicleCard/Card';

//CSS
import '../../../css/components/shared/vehicleCard/ListVehicleCard.css';

function ListVehicleCard({
    history,
    vehicleList,
    selectedDetail,
    isLoading,
    parentCurrentPage,
    changeParentCurrentPage,
    limitVehicles,
    lastNumberVehicles,
    options,
    serverTime,
    fetchServerTime,
}) {
    const [optionsPagination, setOptionsPagination] = useState({
        currentPage: parentCurrentPage ? parentCurrentPage : 1,
        totalRecords: lastNumberVehicles ? lastNumberVehicles : 0,
        pageLimit: limitVehicles ? limitVehicles : 6,
        pageNeighbours: 0,
    });

    useEffect(() => {
        setOptionsPagination(currentOptions => ({
            ...currentOptions,
            currentPage: parentCurrentPage,
        }));
    }, [parentCurrentPage]);

    useEffect(() => {
        setOptionsPagination(currentOptions => ({
            ...currentOptions,
            totalRecords: lastNumberVehicles,
        }));
    }, [lastNumberVehicles]);

    const printCardType = useCallback(
        vehicleInfo => {
            if (options.typeCards === 'default') {
                return (
                    <VehicleAuctionCard
                        vehicle={vehicleInfo}
                        history={history}
                        serverTime={serverTime}
                        fetchServerTime={fetchServerTime}
                    />
                );
            } else if (options.typeCards === 'adjudications') {
                return (
                    <VehicleAdjudgedCard
                        vehicleParent={vehicleInfo}
                        history={history}
                        selectedDetail={selectedDetail}
                    />
                );
            } else if (options.typeCards === 'soldvwr') {
                return (
                    <VehicleSoldVWRCard
                        vehicleParent={vehicleInfo}
                        history={history}
                        selectedDetail={selectedDetail}
                    />
                );
            }else if (options.typeCards === 'dealerReceptor') {
                return (
                    <VehicleDealerReceptorCard
                        vehicleParent={vehicleInfo}
                        history={history}
                        serverTime={serverTime}
                        fetchServerTime={fetchServerTime}
                    />
                );
            }
        },
        [
            fetchServerTime,
            history,
            options.typeCards,
            selectedDetail,
            serverTime,
        ]
    );

    const printSkeletonCardType = index => {
        if (options.typeCards === 'default') {
            return <VehicleCardSkeleton key={index}> </VehicleCardSkeleton>;
        } else if (options.typeCards === 'adjudications') {
            return (
                <VehicleAdjudgedCard
                    key={index}
                    vehicleParent={{
                        IdVehicleAdjudication: index,
                        skeleton: true,
                    }}
                />
            );
        } else if (options.typeCards === 'dealerReceptor') {
            return (
                <VehicleDealerReceptorCard
                    key={index}
                    vehicleParent={{ Id: index, skeleton: true }}
                    fetchServerTime={fetchServerTime}
                />
            );
        }
    };

    const printListCards = () => {
        let listCards = [];
        let typeCardClass = 'c-list-vehicle-card__item ';
        if (options.typeCards != 'default')
            typeCardClass += 'c-list-vehicle-card__item--full';

        if (isLoading) {
            for (let index = 0; index < limitVehicles; index++) {
                listCards.push(
                    <li className={typeCardClass} key={index}>
                        {printSkeletonCardType(index)}
                    </li>
                );
            }
        } else {
            if (vehicleList != null && vehicleList.length > 0) {
                listCards = vehicleList.map((vehicleInfo, index) => (
                    <li
                        className={typeCardClass}
                        key={vehicleInfo.Id + '_' + index}
                    >
                        {printCardType(vehicleInfo, index)}
                    </li>
                ));
            }
        }

        return <ul className="c-list-vehicle-card">{listCards}</ul>;
    };

    return (
        <Fragment>
            {printListCards()}
            <Pagination
                options={optionsPagination}
                onPageChanged={changeParentCurrentPage}
                isLoading={isLoading}
            />
        </Fragment>
    );
}

export default ListVehicleCard;
